import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
	loaderContainer: {
		height: (props) => props.height,
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	circularProgress: {
		margin: 'auto',
	},
}));

function Loader(props) {
	const classes = useStyles(props);
	return (
		<Box className={classes.loaderContainer}>
			<CircularProgress
				color={props.color}
				size={props.size}
				thickness={props.thickness}
				className={classes.circularProgress}
			/>
		</Box>
	);
}

Loader.propTypes = {
	color: PropTypes.string,
	size: PropTypes.number,
	thickness: PropTypes.number,
	height: PropTypes.string,
};

Loader.defaultProps = {
	color: 'primary',
	size: 40,
	thickness: 3.6,
	height: '422px',
};
export default Loader;
